import { useState } from "react";
import { api, fmtDate } from "../api";
import { useLang, useT } from "../i18n";
import { Head, useApi, useShell } from "../ui";

interface Msg { id: string; from: "partner" | "team"; body: string; at: string }

/** The Inbox (docs/37 S14): the partner's thread with the Partner Desk, a CRM conversation. */
export function Inbox() {
  const t = useT();
  const lang = useLang();
  const { me, toast } = useShell();
  const { data, reload } = useApi<{ configured: boolean; teamId?: string; messages: Msg[] }>("/inbox");
  const [body, setBody] = useState("");
  return (
    <>
      <Head eyebrow={t("inbox.eyebrow")} title={t("nav.inbox")} extra={<button className="btn line" type="button" onClick={reload}>Refresh</button>} />
      <section className="card" data-testid="inbox">
        {data && !data.configured ? <p className="muted">The Inbox is not connected to the CRM in this environment.</p> : null}
        {(data?.messages ?? []).length ? data!.messages.map((m) => (
          <div key={m.id} className={`msg ${m.from}`} style={{ display: "flex", justifyContent: m.from === "partner" ? "flex-end" : "flex-start", margin: ".5rem 0" }}>
            <div style={{ maxWidth: "70%", background: m.from === "partner" ? "var(--brass-soft)" : "var(--side)", borderRadius: 12, padding: ".6rem .8rem" }}><small className="muted">{m.from === "partner" ? me.session.name : `${me.accountManager.name} · Partner Desk`} · {fmtDate(m.at, lang)}</small><p style={{ whiteSpace: "pre-wrap" }}>{m.body}</p></div>
          </div>
        )) : <p className="muted">{t("inbox.empty")}</p>}
        <form className="mform" style={{ marginTop: "1rem" }} onSubmit={(e) => { e.preventDefault(); api("/inbox", { body: { body } }).then(() => { setBody(""); reload(); toast("Sent to the Partner Desk."); }, (x: Error) => toast(x.message)); }}>
          <label className="f">{t("inbox.write")}<textarea required rows={3} value={body} onChange={(e) => setBody(e.target.value)} /></label>
          <div className="q-actions"><button className="btn ink" type="submit">{t("inbox.send")}</button></div>
        </form>
      </section>
    </>
  );
}
